import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { projects, getProjectSlug } from '../data/projects';
import './WorkPage.css';

const WorkPage = () => {
    const navigate = useNavigate();
    const [hoveredProject, setHoveredProject] = useState(null);
    const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

    const handleProjectClick = (project) => {
        if (project.externalLink) {
            // Navigate in the same tab to static folder
            window.location.assign(project.externalLink);
        } else {
            const projectSlug = getProjectSlug(project.title);
            const event = new CustomEvent('navigation', { detail: { path: `/work/${projectSlug}` } });
            window.dispatchEvent(event);
        }
    };

    const sorted = [...projects].filter(project => !project.hidden).sort((a, b) => parseInt(b.year) - parseInt(a.year));

    useEffect(() => {
        const onMove = (e) => setCursorPosition({ x: e.clientX, y: e.clientY });
        document.addEventListener('mousemove', onMove);
        return () => document.removeEventListener('mousemove', onMove);
    }, []);

    return (
        <div className="work-page">
            <div className="work-header">
                <h1 className="animate-line">Projects</h1>
                <p className="work-subtitle animate-line">Selected works, wip projects, concepts and ideas.</p>
            </div>

            <div className="projects-list">
                {sorted.map((project) => (
                    <button
                        key={project.id}
                        className="project-row"
                        onClick={() => handleProjectClick(project)}
                        onMouseEnter={() => setHoveredProject(project)}
                        onMouseLeave={() => setHoveredProject(null)}
                    >
                        <div className="project-row-title">
                            <span className="project-row-name">{project.title}</span>
                            <span className="project-row-meta">{project.category}</span>
                        </div>
                        <div className="project-row-desc">{project.description}</div>
                    </button>
                ))}
            </div>

            {hoveredProject && (
                <div
                    className="hover-preview"
                    style={{ 
                        left: cursorPosition.x + 20, 
                        top: cursorPosition.y + 20,
                        aspectRatio: (() => {
                            const val = hoveredProject?.aspect || '16:9';
                            const parts = val.replace(/\s/g, '').split(':');
                            if (parts.length === 2) {
                                const w = parseFloat(parts[0]);
                                const h = parseFloat(parts[1]);
                                if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) return `${w} / ${h}`;
                            }
                            return '16 / 9';
                        })()
                    }}
                >
                    {(() => {
                        const src = hoveredProject.image || '';
                        const isImage = /\.(png|jpe?g|webp|gif)$/i.test(src) || src.startsWith('/');
                        if (isImage) {
                            return <img src={src} alt={hoveredProject.title} />;
                        }
                        return (
                            <div className="hover-preview-bg" style={{ background: src }}></div>
                        );
                    })()}
                    <div className="hover-dissolve">
                        {Array.from({ length: 96 }).map((_, i) => (
                            <div
                                key={i}
                                className="hover-dissolve-cell"
                                style={{ animationDelay: `${(i * 11) % 240}ms` }}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default WorkPage; 